<template>
    <v-container fluid fill-height>
        <v-layout justify-center>
            <v-responsive max-width="1024px" width="100%" height="100%">
                <v-row class="mt-4">
                    <v-col cols="12" md="6">
                        <v-card>
                            <v-toolbar color="info lighten-1" dense>
                                <v-toolbar-title class="white--text subtitle-2">브랜드 </v-toolbar-title>
    
                                <v-spacer></v-spacer>
                                <v-btn :disabled="!$hasScope(['root', 'admin'])" color="accent" fab dark small absolute bottom right @click="$refs.brandDialog.open()">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </v-toolbar>
    
                            <v-card-text>
                                <v-draggable-treeview v-if="brands.length" v-model="brands" :disabled="!$hasScope(['root', 'admin'])" item-key="_id" children="children" group="brands" @click="change" dense></v-draggable-treeview>
                                <span v-else>등록된 브랜드가 없습니다.<br>브랜드를 등록해주세요</span>
                            </v-card-text>

                        </v-card>
    
                        <v-row>
                            <v-spacer></v-spacer>
                            <v-col md="auto">
    
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card :disabled="!brand._id || !$hasScope(['root', 'admin'])">
                            <v-card-title class="subtitle-1">브랜드 기본정보</v-card-title>
                            <v-card-text>
                                <v-text-field v-model="brand.name" label="브랜드 이름" placeholder=" " hide-details></v-text-field>
                                <v-row class="mt-6">
                                    <v-col class="py-0">
                                        <v-text-field v-model="brand.code" label="브랜드 코드" placeholder=" " dense hide-details></v-text-field>
                                    </v-col>
                                </v-row>
                                <product-image v-model="brand.thumb" label="썸네일" ></product-image>
                                <product-image v-model="brand.subThumb" label="서브 썸네일" ></product-image>
                            </v-card-text>
                        </v-card>
    
                        <v-row>
                            <v-col md="auto">
                                <v-btn color="grey darken-1" class="white--text" @click="remove(brand)" :disabled="!brand._id || brand.root || !$hasScope(['root', 'admin']) ? true : false">삭제</v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col md="auto">
                                <v-btn color="primary" @click="update(brand)" :disabled="!brand._id || !$hasScope(['root', 'admin'])">저장</v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
    
                <brand-dialog ref="brandDialog" @save="search"></brand-dialog>
            </v-responsive>
        </v-layout>
    </v-container>
    </template>
    
    <script>
    import api from "@/api";
    import BrandDialog from "@/components/console/shop/brands/brand-dialog.vue";
    import BrandSelect from '@/components/console/shop/brands/brand-select.vue';
    import ProductImage from "@/components/console/shop/products/product-image.vue";
    
    export default {
        components: {
            BrandDialog,
            BrandSelect,
            ProductImage
        },
        data() {
            return {
                dialog: false,
    
                loading: true,
    
                headers: [],
                categories: [],
                category: {
                    banners: [],
                    name: null,
                },
                brands: [],
                brand: {},
                editItem: null,
                defaultItem: {
                    name: null,
                    code: null,
                },
    
                banner: null,
                pickup: null,
            };
        },
        mounted(){
            this.init();
        },
        methods: {
            async init(){
                await this.search();
                this.loading = false;
            },
    
            async search(){
                let { categories } = await api.console.shop.categories.gets({ params: { depth: 1 } });
                this.categories = categories;

                let { brands } = await api.console.shop.brands.gets()
                this.brands = brands;
            },
    
            async change(brand){
                try{
                    if(brand.thumb) brand.thumb = await api.getResource(brand.thumb);
                    if(brand.subThumb) brand.subThumb = await api.getResource(brand.subThumb);
                }
                catch(error){
                    console.error(error);
                }
                this.brand = brand;
            },
    
            /////////////////////////////////////////
            // 브랜드 수정
            /////////////////////////////////////////
            async update(brand) {
                let { brand: udateBrand } = await api.console.shop.brands.put(brand);
                if(brand.thumb) await api.console.shop.brands.postThumb(udateBrand, brand.thumb)
                if(brand.subThumb) await api.console.shop.brands.postSubThumb(udateBrand, brand.subThumb)
                this.brand = {}
                alert("저장되었습니다");
                await this.search();
            },
    
            /////////////////////////////////////////
            // 브랜드 삭제
            /////////////////////////////////////////
            async remove(brand) {
                try {
                    this.loading = true;
    
                    await api.console.shop.brands.delete(brand);
                    this.brand = {}
                    await this.search();
                } catch (error) {
                    console.error(error);
                    alert(error.response ? error.response.data.message : error.message);
                }
            },
    
            sort(brands, _parents = [], depth = 1) {
                for(var brand of brands) {
                    brand.sequence = brands.indexOf(brand);
                    brand.depth = depth;
                    brand._parents = _parents;
    
                    if (brand.children) {
                        brand._children = brand.children.map((child) => { return child._id });
                        this.sort(brand.children, [].concat(brand._parents, brand._id), depth + 1);
                    }
                    api.console.shop.brands.put(brand);
                }
            },
    
            insertBanner(banner){
                this.category.banners.push(banner);
            },
    
            removeBanner(banner){
                this.category.banners.splice(this.category.banners.indexOf(banner), 1);
                this.category.banners.push(undefined);
            },
    
            insertPickup(pickup){
                this.category.pickups.push(pickup);
                this.category._pickups.push(pickup._id);
            },
    
            removePickup(pickup){
                this.category.pickups.splice(this.category.pickups.findIndex(item => item._id == pickup._id), 1);
                this.category._pickups.splice(this.category._pickups.findIndex(item => item == pickup._id), 1);
            },
    
            createObjectURL(file){
                try{
                    return URL.createObjectURL(file);
                }
                catch(error){
                    return null;
                }
            }
        },
        watch: {
            dialog(value){
                if(value) this.editItem = Object.assign({}, this.defaultItem);
            },
            brands() {
                if(!this.loading) this.sort(this.brands);
            }
        }
    }
    </script>
    